if (!customElements.get("load-more-section-button")) {
  customElements.define(
    "load-more-section-button",
    class LoadMoreSectionButton extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener("click", this.handleClick.bind(this));
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleClick.bind(this));
      }

      handleClick(e) {
        e.preventDefault();

        if (this.getAttribute("disabled") === "true") {
          return;
        }
        this.startLoading();
      }

      getNextPage() {
        return parseInt(this.getAttribute("data-page") ?? 1) + 1;
      }

      getUrl() {
        let url = "https://" + window.routes.domain; //Root
        url += this.getAttribute("data-collection-url"); //Main collection page to load products
        url += "?sections=main-collection-product-grid"; //Only need the one section
        url += "&page=" + this.getNextPage();
        url += "&limit=" + this.getAttribute("data-max") ?? 8;
        url += "&quick_add=" + this.getAttribute("data-quick-add") ?? "true";
        return url;
      }

      async startLoading() {
        this.setAttribute("disabled", "true");
        this.setAttribute("data-loading", "true");
        this.innerHTML = this.getAttribute("data-loading-text");

        const resp = await fetch(this.getUrl());
        const json = await resp.json();
        const parsedHTML = new DOMParser().parseFromString(
          json["main-collection-product-grid"],
          "text/html",
        );

        const newItems = parsedHTML.querySelectorAll(".grid__item");
        const targetWrapper = document.getElementById(
          this.getAttribute("data-section-id"),
        );

        const targetList = targetWrapper?.querySelector(".product-grid");
        targetList.append(...newItems);

        const allItemsCount =
          targetList?.querySelectorAll(".grid__item").length;

        if (
          allItemsCount >= parseInt(this.getAttribute("data-products-count")) ||
          newItems.length === 0
        ) {
          this.setAttribute("disabled", true);
          this.classList.add("hidden");
          return;
        }

        this.setAttribute("data-page", this.getNextPage());
        this.removeAttribute("disabled");
        this.removeAttribute("data-loading");
        this.innerHTML = this.getAttribute("data-ready-text");
      }
    },
  );
}
